import { render, staticRenderFns } from "./JournalDetailsPage.vue?vue&type=template&id=69edaaf5"
import script from "./JournalDetailsPage.vue?vue&type=script&lang=js"
export * from "./JournalDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./JournalDetailsPage.vue?vue&type=style&index=0&id=69edaaf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports